import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const EmployeeCTCReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [ctcReport, setCTCReport] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [filterFormData, setFilterData] = useState([
    { label: "Scale", value: 1 },
    { label: "Employee", value: "" },
  ]);
  const [scaleList, setScaleList] = useState([]);

  const dispatch = useDispatch();
  useEffect(() => {
    fetchIndexApi();
    fetchEmpCTCReport();
    dispatch(updateNavbarHeading("Employee CTC Report"));
     const scaleOpt = { value: 1, label: "Current Scale" };
    const scalesList = [
      {
        value: scaleOpt.value,
        label: scaleOpt.label,
      },
    ];
    setScaleList(scalesList);
  }, []);
  const columns = {
    EmployeeID: { text: "EMP ID", visible: true },
    EmpName: { text: "Name", visible: true },
    Designation: { text: "Designation", visible: true },
    JoiningDate: { text: "Joining Date", align: "center", visible: true },
    Basic: { text: "BASIC", align: "end", visible: true },
    HRA: { text: "HRA", align: "end", visible: true },
    Spl_Allow: { text: "PDA", align: "end", visible: true },
    Conv_Allow: { text: "C.ALLOW", align: "end", visible: true },
    LTA: { text: "LTA", align: "end", visible: true },
    OA: { text: "OA", align: "end", visible: true },
    NPS: { text: "NPS", align: "end", visible: true },
    Gross_Salary: { text: "GROSS", align: "end", visible: true },
    Consulting_Incentives: { text: "CN INC", align: "end", visible: true },
    Content_Incentives: { text: "CT INC", align: "end", visible: true },
    Training_Incentives: { text: "TRG INC", align: "end", visible: true },
    HR_Incentives: { text: "HR INC", align: "end", visible: true },
    CCA: { text: "CCA", align: "end", visible: true },
    Revenue_Incentives: { text: "REV. INC", align: "end", visible: true },
    Team_Incentive: { text: "TEAM INC", align: "end", visible: true },
    Project_Incentives: { text: "PROJ. INC", align: "end", visible: true },
    Act_Mng: { text: "ACCT MGMT INC", align: "end", visible: true },
    Incentives: { text: "INCENTIVE", align: "end", visible: true },
    PF: { text: "PF", align: "end", visible: true },
    LeaveEncash: { text: "LWW", align: "end", visible: true },
    Bonus: { text: "BONUS", align: "end", visible: true },
    Gratuity: { text: "GRATUITY", align: "end", visible: true },
    Mediclaim: { text: "MEDICLAIM", align: "end", visible: true },
    CTC: { text: "CTC", align: "end", visible: true },
    Band: { text: "Band", visible: true, },
    MinBandSalary: { text: "Min Band Sal", visible: false, },
    MaxBandSalary: { text: "Max Band Sal", visible: false, },
    MidPoint: { text: "Mid Band Sal", visible: false, },
    CompaRatio: {text: "Compa Ratio %",visible: true,},
  };

  useEffect(() => {
   
  }, []);

  const formDatas = [
    { name: "Scale", type: "Select", options: [...scaleList] },
    { name: "Employee", type: "Select", options: [...employeeList] },
  ];

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };


  const fetchIndexApi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/calculate-payroll`
      );
      // console.log("check status", response?.status);

      if (response.status === 200) {

        // Employee List
        const emplist = response?.data?.employeelist?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmployeeList(emplist);

      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  }

  const fetchEmpCTCReport = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/8?P_EmployeeID=`
      );
      if (response?.status === 200) {
        SetApiStatus(response?.status);
        const data = response?.data?.data?.data;
        setCTCReport(data);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/8?P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : 0
        }`
      );
      if (response?.status === 200) {
        SetApiStatus(response?.status);
        const data = response?.data?.data?.data;
        setCTCReport(data);

        // Employee List
        const empList = response?.data?.data?.empList.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmployeeList(empList);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };



  const handleReset = () => {
    setFilterData([
      { label: "Scale", value: 1 },
      { label: "Employee", value: "" },
    ])
    fetchEmpCTCReport();
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={ctcReport}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              isSorting={true}
              handleReset={handleReset}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeCTCReport;
